import { trapFocus } from "./vendor/trapFocus.js";

// Main navigation

const mainMenuToggle = document.querySelector('.js-main-menu-toggle');
const mainMenuToggleLabel = document.querySelector('.js-main-menu-toggle-label');
const mainMenu = document.querySelector('.js-main-menu');
const headerFocusableWrappers = document.querySelectorAll('.js-trap-focus');
let isMenuShown = false; 

if (mainMenuToggle) {
    mainMenuToggle.addEventListener('click', function() {
        toggleMenuVisibility(!isMenuShown);
        toggleVenueNavVisibility(false);
    });
}

function toggleMenuVisibility(value) {
    isMenuShown = value;
    document.body.classList.toggle('state--nav-open', value);
    mainMenuToggleLabel.textContent = (value ? 'Close' : 'Menu');
    mainMenuToggle.setAttribute("aria-expanded", value);
    mainMenu.classList.toggle('is-open', value);
    trapFocus(headerFocusableWrappers, value ? mainMenuToggle : null);
}

// Desktop Venue navigation

const venueNavToggle = document.querySelector('.js-venue-nav-toggle');
const venueNav = document.querySelector('.js-venue-nav');
let isVenueNavShown = false; 

if (venueNavToggle) {
    venueNavToggle.addEventListener('click', function() {
        toggleVenueNavVisibility(!isVenueNavShown);
        toggleMenuVisibility(false);
    });
}

function toggleVenueNavVisibility(value) {
    isVenueNavShown = value;
    document.body.classList.toggle('state--venue-nav-open', value);
    venueNavToggle.setAttribute("aria-expanded", value);
    venueNav.classList.toggle('is-open', value);
}

// Mobile Venue navigation

const mobileVenueNavToggle = document.querySelector('.js-mobile-venue-nav-toggle');
const mobileVenueNav = document.querySelector('.c-navigation__venue-nav-list');
let isMobileVenueNavShown = false; 

if (mobileVenueNavToggle) {
    mobileVenueNavToggle.addEventListener('click', function() {
        toggleMobileVenueNavVisibility(!isMobileVenueNavShown);
    });
}

function toggleMobileVenueNavVisibility(value) {
    isMobileVenueNavShown = value;
    document.body.classList.toggle('state--mobile-venue-nav-open', value);
    mobileVenueNavToggle.setAttribute("aria-expanded", value);
    mobileVenueNav.classList.toggle('is-open', value);
}

export { toggleMenuVisibility, toggleVenueNavVisibility, toggleMobileVenueNavVisibility };